"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const react_1 = require("react");
const lodash_1 = require("lodash");
exports.default = (config) => {
    // historyHelper is here as we don't have a react dom history object to work with ( which causes a change to
    // propagate through the component tree ), we can use it to force a state change, which causes the component using
    // this hook to refresh.
    const [, setHistoryHelper] = (0, react_1.useState)(window.location.hash);
    // Respond to external changes to location.hash
    (0, react_1.useLayoutEffect)(() => {
        const onHashChanged = () => {
            setHistoryHelper(location.hash);
        };
        window.addEventListener("hashchange", onHashChanged);
        return () => {
            window.removeEventListener('hashchange', onHashChanged);
        };
    }, []);
    const { history = window.history, location = window.location, parameters = {}, defaults = {}, } = config;
    const replace = (newPath) => {
        if (typeof history.replace === 'function') {
            history.replace(newPath);
        }
        else if (typeof location.replace === 'function') {
            const path = newPath.replace(/^.*#/, '#');
            location.replace(path);
            setHistoryHelper(path);
        }
    };
    const normalizeState = (input, format = 'object') => {
        let normalized;
        if (typeof input === 'string') {
            normalized = qs_1.default.parse(input.replace(/^#!/, ''), {
                ignoreQueryPrefix: true,
            });
            (0, lodash_1.forEach)(parameters, (type, parameter) => {
                if (normalized.hasOwnProperty(parameter)) {
                    switch (type) {
                        case 'csv':
                            normalized[parameter] = normalized[parameter].split(',');
                            break;
                        case 'int':
                            normalized[parameter] = parseInt(normalized[parameter], 10);
                            break;
                        case 'bool':
                            normalized[parameter] = !!normalized[parameter];
                            break;
                        default:
                            break;
                    }
                }
            });
        }
        else {
            normalized = (0, lodash_1.cloneDeep)(input);
        }
        Object.keys(normalized).forEach((parameter) => {
            if (!parameters.hasOwnProperty(parameter)) {
                delete normalized[parameter];
            }
        });
        (0, lodash_1.forEach)(parameters, (type, parameter) => {
            if (normalized.hasOwnProperty(parameter)) {
                switch (type) {
                    case 'int':
                        if (isNaN(normalized[parameter])) {
                            delete normalized[parameter];
                        }
                        break;
                    case 'csv':
                    case 'array':
                        if (!(0, lodash_1.isArray)(normalized[parameter])) {
                            delete normalized[parameter];
                        }
                        break;
                    default:
                        break;
                }
            }
            if (!normalized.hasOwnProperty(parameter) &&
                defaults.hasOwnProperty(parameter)) {
                normalized[parameter] = defaults[parameter];
            }
        });
        switch (format) {
            case 'query':
                (0, lodash_1.forEach)(parameters, (type, parameter) => {
                    if (normalized.hasOwnProperty(parameter)) {
                        switch (type) {
                            case 'csv':
                                normalized[parameter] = normalized[parameter].join(',');
                                break;
                            case 'bool':
                                normalized[parameter] = normalized[parameter]
                                    ? 1
                                    : 0;
                                break;
                            default:
                                break;
                        }
                    }
                });
                Object.keys(normalized).forEach((key) => {
                    if (!normalized[key]) {
                        delete normalized[key];
                    }
                });
                return '#!' + qs_1.default.stringify(normalized);
            case 'object':
            default:
                return normalized;
        }
    };
    const state = normalizeState(location.hash);
    const updateState = (next) => {
        const stringifiedState = normalizeState(Object.assign(Object.assign({}, state), next), 'query');
        if (stringifiedState !== location.hash) {
            replace(location.pathname + stringifiedState);
        }
    };
    return [state, normalizeState(state, 'query'), updateState, normalizeState];
};
